// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"style_loading-container__tAQV_"};